import React, { useRef, useEffect, useState, Fragment } from "react";
import { connect } from "react-redux";
import Table from "../Table";
import Card from "../Card";
import { getMyProjects } from "../../../redux/actions/Projects";

const MyProjects: React.FC<{
  myProjects: any;
  getMyProjects: () => void;
  highlightProject: any;
  setHighlightProject: any;
  setEllipsisClick: any;
}> = ({
  myProjects,
  getMyProjects,
  highlightProject,
  setHighlightProject,
  setEllipsisClick,
}) => {
  const [viewState, setViewState] = useState("box") as any;
  const handleBoxClick = () => {
    setViewState("box");
  };

  const handleListClick = () => {
    setViewState("list");
  };

  useEffect(() => {
    getMyProjects();
  }, []);

  return (
    <>
      <div
        className="subTitle"
        style={{
          display: "flex",
          flexDirection: "row",
        }}
      >
        <p
          style={{ paddingLeft: "25px", fontWeight: "bold", fontSize: "16px" }}
        >
          My Projects
        </p>
        <div className="push">
          <i
            onClick={handleBoxClick}
            className="fa fa-th"
            style={{
              marginRight: "30px",
              color: viewState === "box" ? "black" : "lightgrey",
            }}
          ></i>
          <i
            onClick={handleListClick}
            style={{ color: viewState === "list" ? "black" : "lightgrey" }}
            className="fa fa-list-ul"
          ></i>
        </div>
      </div>
      <div
        className="header2"
        style={
          viewState === "box"
            ? {
                maxHeight: "100vh",
                overflowY: "auto",
              }
            : { marginTop: 0 }
        }
      >
        {/* all your projects here  */}
        {viewState === "box" ? (
          myProjects?.map((item: any, index: number) => (
            <Card
              key={index}
              item={item}
              index={index}
              bottom={index === myProjects.length - 1}
              highlightProject={highlightProject}
              setHighlightProject={setHighlightProject}
              setEllipsisClick={setEllipsisClick}
              // allItems={myProjects}
            />
          ))
        ) : (
          <Table
            projectList={myProjects}
            // handleClick={() => console.log("CLicked")}
            // setProjectClicked={() => console.log("CLicked")}
            // openDeleteM={() => console.log("CLicked")}
            adminFolderState={false}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => ({
  myProjects: state.projects.myProjects,
});

export default connect(mapStateToProps, { getMyProjects })(MyProjects) as any;
